import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=13d3ce21&scoped=true"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=13d3ce21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3ce21",
  null
  
)

export default component.exports